/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import EasyToDriverPage from 'src/pages/ReportsPages/ReportsBoard/CommercialsReportsPages/EasyToDriverPage'
import boardReportsService from 'src/services/boardReportsService'

const EasyToDriveContainer = () => {
  const [total, setTotals] = useState([])
  const [totalSegment, setTotalSegment] = useState([])
  const [moped, setMoped] = useState([])
  const [mopedSegment, setMopedSegment] = useState([])
  const [scooter, setScooter] = useState([])
  const [scooterSegment, setScooterSegment] = useState([])
  const [gTotal, setGTotal] = useState([])
  const [gTotalA, setGTotalA] = useState([])
  const [gTotalB, setGTotalB] = useState([])
  const [gmSegment, setGMSegment] = useState([])
  const [gMoped, setGMoped] = useState([])
  const [gMopedB, setGMopedB] = useState([])
  const [gTScooter, setGTScooter] = useState([])
  const [gScooterA, setGTScooterA] = useState([])
  const [gScooterB, setGTScooterB] = useState([])

  const [selectedDate, setSelectedDate] = useState(new Date())

  const reloadTotalEasyToDrive = async () => {
    const [total, totalSegment, moped, scooterSegment, mopedSegment, scooter] = await Promise.all([
      boardReportsService.getTotalMarkes('4', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('5', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('6', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('9', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('7', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('8', selectedDate.getFullYear()),
    ])

    setScooterSegment(scooterSegment)
    setMopedSegment(mopedSegment)
    setMoped(moped)
    setTotals(total)
    setTotalSegment(totalSegment)
    setScooter(scooter)
  }

  const reloadGraphics = async () => {
    const [gTotal, gTotalA, gTotalB, gMoped, gmSegment, gMopedB, gTScooter, gScooterA, gScooterB] = await Promise.all([
      boardReportsService.getTotalMarketsGraphics('4', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('5a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('5b', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('6', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('7a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('7b', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('8', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('9a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('9b', selectedDate.getFullYear()),
    ])
    setGTotal(gTotal)
    setGTotalA(gTotalA)
    setGTotalB(gTotalB)
    setGMoped(gMoped)
    setGMSegment(gmSegment)
    setGMopedB(gMopedB)
    setGTScooter(gTScooter)
    setGTScooterA(gScooterA)
    setGTScooterB(gScooterB)
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadTotalEasyToDrive()
    reloadGraphics()
  }, [selectedDate])

  return (
    <EasyToDriverPage
      total={total}
      gTotal={gTotal}
      gTotalA={gTotalA}
      gTotalB={gTotalB}
      gScooterA={gScooterA}
      gScooterB={gScooterB}
      gTScooter={gTScooter}
      totalSegment={totalSegment}
      scooterSegment={scooterSegment}
      scooter={scooter}
      moped={moped}
      gMoped={gMoped}
      gMopedB={gMopedB}
      gmSegment={gmSegment}
      mopedSegment={mopedSegment}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
    />
  )
}

export default EasyToDriveContainer
